module.exports = __webpack_public_path__ + "static/psychic-interior-06-bbb8bd13b8d2648f66f0d1bcc1a5db8c.jpg";